import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { HandHeart, Sparkles, ArrowRight } from "lucide-react";

const KEY = "ata_welcome_seen";

export const WelcomeDialog = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setOpen(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => { localStorage.setItem(KEY, "1"); setOpen(false); };
  const go = () => { close(); navigate("/commander"); };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-md rounded-none border-2 border-black bg-white p-0 overflow-hidden" data-testid="welcome-dialog">
        <div className="bg-black text-white px-6 pt-7 pb-6">
          <div className="flex items-center gap-2 text-brand-amber mb-3">
            <HandHeart className="w-6 h-6" />
            <span className="uppercase tracking-widest text-xs font-semibold">Commandez malin, mangez local</span>
          </div>
          <DialogHeader className="space-y-0 text-left">
            <DialogTitle className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter leading-tight">
              Ici, chaque commande a<br />un vrai goût de <span className="text-brand-red">local</span>.
            </DialogTitle>
            <DialogDescription className="sr-only">Message de bienvenue Asia Take Away</DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-6 py-6 space-y-4">
          <p className="text-[15px] leading-relaxed text-neutral-800">
            En commandant <strong>directement ici</strong> — sans plateforme qui prend sa commission — vous soutenez
            un vrai petit restaurant de quartier à Lausanne.
          </p>
          <div className="flex items-start gap-3 border border-black/10 bg-brand-amber/10 p-3">
            <Sparkles className="w-5 h-5 text-brand-red shrink-0 mt-0.5" />
            <p className="text-sm text-neutral-800">
              <strong>Et c'est gagnant-gagnant :</strong> pas d'intermédiaire = des prix plus doux pour vous,
              et 100 % qui revient à ceux qui cuisinent avec passion.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 pt-1">
            <Button onClick={go} className="rounded-none bg-brand-red hover:bg-brand-red/90 h-12 flex-1 text-base" data-testid="welcome-order-btn">
              Je découvre la carte <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button onClick={close} variant="outline" className="rounded-none border-black/30 bg-transparent hover:bg-black/5 h-12 sm:w-28" data-testid="welcome-close-btn">
              Plus tard
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
